module.exports = __webpack_public_path__ + "static/media/RA-AP0005B_02.15fbdec1.png";